<button type="button" class="btn btn-link" (click)="toggleShowHelp()">
  Aide
  <lucide-icon [img]="icons.help"></lucide-icon>
</button>
@if (showDialog()) {
  <div class="help-overlay d-flex justify-content-center align-items-center">
    <div class="container">
      <div class="row">
        <div class="col col-auto mx-auto">
          <div class="alert alert-primary" role="alert">
            <h4 class="alert-heading">Une question ? Besoin d'aide ?</h4>
            <p class="my-2">
              Consulte <a target="_blank" [routerLink]="routes.faq">les questions fréquentes</a>
            </p>
            <p>
              Écris-nous: <br/>
              <lucide-icon [img]="icons.whatsapp"></lucide-icon> whatsapp: <a [href]="supportWhatsappUrl()" target="_blank">{{ whatsappPhone }}</a><br/>
              <lucide-icon [img]="icons.mail"></lucide-icon> email: <a [href]="supportEmailUrl()" target="_blank">{{ supportEmail }}</a>
            </p>
            <p class="mb-0 text-end">
              <button type="button" class="btn btn-light" (click)="okClicked()">J'ai compris</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
